import {InjectionToken} from '@angular/core';
import {Observable} from 'rxjs';
import {DialogTurnRequest, DialogTurnResponse} from './dialog.models';

/** Field names match the wire response as-is (snake_case), same convention as
 *  `DialogTurnRequest`/`DialogTurnResponse` — no camelCase mapping layer exists. */
export interface DialogSessionPeek {
  found: boolean;
  session_id?: string;
  state?: 'clarify' | 'confirm' | 'idle';
  message?: string;
  transcript?: {role: 'user' | 'assistant'; text: string; at: string}[];
}

export interface DialogApi {
  turn(householdId: number, request: DialogTurnRequest): Observable<DialogTurnResponse>;
  invalidateSession(householdId: number, sessionId: string): Observable<void>;
  peekActiveSession(householdId: number): Observable<DialogSessionPeek>;
}

/**
 * Swaps between `HttpDialogApi` (default) and `MockDialogApi` (local dev / tests) via a
 * single provider line in AppModule — see `{ provide: DIALOG_API, useExisting: ... }`.
 */
export const DIALOG_API = new InjectionToken<DialogApi>('DIALOG_API');
